import ColumnFilter from 'components/ui/Table/Filters/ColumnFilter'
import Table from 'components/ui/Table/Table'
import { useModal } from 'contexts/ModalContext'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ImSpinner9 } from 'react-icons/im'
import { LuCheck, LuSquarePen, LuTrash2, LuX } from 'react-icons/lu'
import { Link } from 'wouter'

export default function UserCompGrid({ user, data, handleDelete }) {
  // Hook para modal
  const { modal, openModal } = useModal()

  // Estado para datos formateados de la tabla
  const [getTableData, setTableData] = useState(null)

  // Columnas:
  const columns = [
    {
      title: 'Filtrar por -Usuario-',
      Header: 'Usuario',
      accessor: 'User_UserName',
      Filter: ColumnFilter,
      showInPDF: true,
      showInExcel: true
    },
    {
      title: 'Filtrar por -Correo-',
      Header: 'Correo',
      accessor: 'User_Email',
      Filter: ColumnFilter,
      showInPDF: true,
      showInExcel: true
    },
    {
      title: 'Filtrar por -Nombre-',
      Header: 'Nombre',
      accessor: 'User_Name',
      Filter: ColumnFilter,
      showInPDF: true,
      showInExcel: true
    },
    {
      title: 'Filtrar por -Rol-',
      Header: 'Rol',
      accessor: 'User_Role_Name',
      Filter: ColumnFilter,
      showInPDF: true,
      showInExcel: true
    },
    {
      title: 'Filtrar por -Activo-',
      Header: 'Activo',
      accessor: 'User_Is_Active',
      Filter: ColumnFilter,
      filterType: 'select',
      Cell: (value) => {
        return (
          <div className="px-4 py-4 text-sm whitespace-nowrap">
            {value?.cell?.row?.original?.User_Is_Active === 0 ? (
              <span className="flex items-center justify-center w-6 h-6 bg-red-200 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900 dark:bg-red-900">
                <LuX
                  title="Inactivo"
                  className="text-red-500 dark:text-red-400"
                  size={20}
                />
              </span>
            ) : (
              <span className="flex items-center justify-center w-6 h-6 bg-green-200 rounded-full -start-4 ring-4 ring-white dark:ring-gray-900 dark:bg-green-900">
                <LuCheck
                  title="Activo"
                  className="text-green-500 dark:text-green-400"
                  size={20}
                />
              </span>
            )}
          </div>
        )
      },
      showInPDF: true,
      showInExcel: true
    },
    {
      title: 'Acciones',
      Header: '',
      accessor: 'User_Actions',
      disableSortBy: true, // Deshabilitar ordenación
      Cell: (value) => {
        return (
          <div className="float-right px-4 py-4 text-sm whitespace-nowrap">
            <div className="flex items-center gap-x-6">
              {/* Enlace para editar el registro */}
              <Link
                title="Editar registro"
                href={`/users/${value?.cell?.row?.original?.User_Id}`}
                className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
              >
                <LuSquarePen size={20} />
              </Link>

              {/* Botón para eliminar el registro (visible solo si no eres tú mismo) */}
              {user.id !== value?.cell?.row?.original?.User_Id ? (
                <button
                  title="Eliminar registro"
                  type="button"
                  className="text-gray-500 transition-colors duration-200 dark:hover:text-red-500 dark:text-gray-300 hover:text-red-500 focus:outline-none"
                  onClick={() =>
                    openModal('DeleteModal', {
                      itemName: value?.cell?.row?.original?.User_Name,
                      itemId: value?.cell?.row?.original?.User_Id,
                      handleDelete
                    })
                  }
                >
                  <LuTrash2 size={20} />
                </button>
              ) : null}
            </div>
          </div>
        )
      },
      showInPDF: false,
      showInExcel: false
    }
  ]

  // Adaptar datos para la tabla, agregar prefijo al campo para evitar conflictos con otras tablas
  useEffect(() => {
    if (data) {
      const itemsData = []
      data?.forEach((item) => {
        // IMPORTANTE: Ordenar estos atributos igual que las columnas de la tabla para evitar desajustes en la exportación Excel/PDF
        itemsData.push({
          User_Id: item.id,
          User_UserName: item.username,
          User_Email: item.email,
          User_Name: item.first_name + ' ' + item.last_name,
          User_Role_Name: item.role_name,
          User_Is_Active: item.is_active
        })
      })
      setTableData(itemsData)
    }
  }, [data])

  return getTableData ? (
    <Table
      tableName={'Usuarios'}
      columns={columns}
      createNewItemURL={'/users/new'}
      data={getTableData}
      defaultSort={null}
      allowImportExcel={false}
    />
  ) : (
    <div className="flex items-center content-center justify-center w-full h-full">
      <p
        className="flex flex-col-reverse items-center justify-center h-full font-bold dark:text-[#F5F5F5] text-gray-700"
        title="Cargando..."
      >
        <ImSpinner9 size={70} className="animate-spin" />
      </p>
    </div>
  )
}

UserCompGrid.propTypes = {
  user: PropTypes.object,
  data: PropTypes.array,
  handleDelete: PropTypes.func.isRequired
}
